import axios from 'lib/axios';

import {
  CONNECT_ERROR,
  CONNECT_LOADING,
  CONNECT_SUCCESS
} from 'constants/actions';

import {
  E_CONNECT_UNKNOWN
} from 'constants/errors';

import {
  M_CONNECT_SUCCESS,
  M_DISCONNECT_SUCCESS
} from 'constants/messages';

import { dispatchSetMessage } from './messages';

import { dispatcher } from 'lib/redux';

export const connectProvider = (data) => async () => {
  dispatcher(CONNECT_LOADING, true);

  try {
    await axios.post('connect', data);

    dispatcher(CONNECT_LOADING, false);
    dispatchSetMessage(M_CONNECT_SUCCESS);
    dispatcher(CONNECT_SUCCESS, Date.now());
  } catch (e) {
    dispatcher(CONNECT_LOADING, false);

    if (e.canceled) return;

    if (e.response && e.response.data) {
      return dispatcher(CONNECT_ERROR, e.response.data.message || E_CONNECT_UNKNOWN);
    }

    dispatcher(CONNECT_ERROR, E_CONNECT_UNKNOWN);
  }
};

export const disconnectProvider = (data) => async () => {
  dispatcher(CONNECT_LOADING, true);

  try {
    await axios.delete('connect');

    dispatcher(CONNECT_LOADING, false);
    dispatchSetMessage(M_DISCONNECT_SUCCESS);
    dispatcher(CONNECT_SUCCESS, Date.now());
  } catch (e) {
    dispatcher(CONNECT_LOADING, false);

    if (e.canceled) return;

    dispatcher(CONNECT_ERROR, E_CONNECT_UNKNOWN);
  }
};
